export const REFRESH_COOKIE = 'flashai_refresh';
export const CSRF_COOKIE = 'flashai_csrf';
